import {IServiceFactory} from "../../../../service-factory.interface";
import {MealSsrBase} from "../meal-ssr-base";

//Meniu Lasagna
export default class LsmlSsrType extends MealSsrBase {
    constructor(services: IServiceFactory) {
        super('LSML', services);
    }
}
